import { render, staticRenderFns } from "./WebmailShow.vue?vue&type=template&id=f780affc&scoped=true&"
import script from "./WebmailShow.vue?vue&type=script&lang=js&"
export * from "./WebmailShow.vue?vue&type=script&lang=js&"
import style0 from "./WebmailShow.vue?vue&type=style&index=0&id=f780affc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f780affc",
  null
  
)

export default component.exports